import { Alert } from '@a-ui/react';
import React from 'react';
import BannerLayout from '../../components/BannerLayout';
import Box from '../../components/Box';
import { OverviewLayout } from '../../components/DetailLayout';
import OverviewLayoutSection from '../../components/OverviewLayout/OverviewLayoutSection';
import Typography from '../../components/Typography';
import { translate } from '../../i18n';
import { useAuthentication } from '../../state/Authentication';
import { useSchema } from '../../state/Schema';
import PreferenceDomain from './PreferenceDomain';

const Preferences: React.FC = () => {
  const { schema } = useSchema();

  const {
    state: { user },
  } = useAuthentication();

  const userDomains = React.useMemo(
    () =>
      schema.filter(
        (domain) =>
          Object.keys(user.domains || {}).includes(domain.key) && domain.preferences.length,
      ),
    [Object.keys(user.domains || {}), schema],
  );

  if (schema.length && !userDomains.length) {
    return (
      <BannerLayout title={translate('preferences.title')}>
        <div className="col-lg-6">
          <Alert inline>
            <Typography>{translate('preferences.empty')}</Typography>
          </Alert>
        </div>
      </BannerLayout>
    );
  }

  return (
    <OverviewLayout title="preferences.title">
      {userDomains &&
        userDomains.map((domain) => (
          <OverviewLayoutSection key={`preferences-${domain.key}`} title={domain.name}>
            <Box>
              <PreferenceDomain schema={domain} />
            </Box>
          </OverviewLayoutSection>
        ))}
    </OverviewLayout>
  );
};

export default Preferences;
